import { Injectable, inject } from '@angular/core';
import { GcmNotificationService, Notification, NotificationType } from '@gcm/gcm-ui-angular';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {
  private notificationService = inject(GcmNotificationService);
  private userService = inject(UserService);

  getErrorMessage(err: unknown) {
    // check if user is logged in - as error may be because session timed out
    this.userService.checkIfSessionExistsAndLogoutIfExpired();
    let errorMessage = "Oops! Something went wrong. We're having trouble processing your request. Please try again shortly or contact support if the issue continues."
    const httpErr = err as { error?: { errors?: { message: string }[] } | string };
    const errBody = httpErr?.error;
    if (errBody) {
      if (typeof errBody === 'object' && errBody.errors && errBody.errors.length > 0) {
        errorMessage = errBody.errors[0]?.message ?? errorMessage;
      } else if (typeof errBody === 'string') {
        errorMessage = errBody;
      }
    }
    this.notificationService.notify(new Notification(errorMessage, "Error", NotificationType.error));
    return errorMessage;
  }
}
